export default __webpack_public_path__ + "static/media/cloud-upload.eeff466a.png";